export default __webpack_public_path__ + "static/media/text-logo.4aaae412.svg";